import Api from "@repo/api";
import RestApi, { Get } from "@repo/rest/RestApi";
import Env from "@repo/utils-client/Env";

export default RestApi.create<{
  e2e: {
    emails: {
      "confirmation-token": Get<{ email: string }, { token: string }>;
    };
  };
}>(Env.resolveUrl(Api.origin));

export const appApi = RestApi.create<{
  region: Get<{}, { region: string; country: string }>;
}>(
  `${import.meta.env.MOBILE ? Env.resolveUrl(import.meta.env.WEB_ORIGIN) : ""}/api`
);
